import { createContext, useContext, type ReactNode } from 'react'
import { useTokens } from './useTokens'

// Shares one active-token state across the whole app so the status header's live
// countdown reflects what modules are using (and updates the instant a token is
// minted). Modules call useActiveTokens() instead of useTokens() directly.
type TokenCtx = ReturnType<typeof useTokens>

const Ctx = createContext<TokenCtx | null>(null)

export function TokenProvider({ children }: { children: ReactNode }) {
  const value = useTokens()
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>
}

export function useActiveTokens(): TokenCtx {
  const v = useContext(Ctx)
  if (!v) throw new Error('useActiveTokens must be used inside <TokenProvider>')
  return v
}
